/**
 * Twee dingen in de winkelwagen (PDP-redesign §3) die de theme-componenten niet doen:
 *
 * 1. "Verwijderen" op een Kaching-bundel haalt alle regels van die bundel weg, het
 *    cadeau inbegrepen, in één /cart/update. De sleutels staan op de knop
 *    (data-bundle-keys, zie snippets/cart-products.liquid). Daarna dezelfde
 *    CartUpdateEvent als de theme zelf stuurt, met de nieuwe HTML van de lade erin,
 *    zodat cart-items-component, het bolletje bij het icoon en de rest meebewegen.
 *
 * 2. `cart_cross_sell_add` als iemand de ene aanbeveling in de lade toevoegt. Het
 *    toevoegen zelf gaat via de gewone product-form-component, dus Wetracked ziet een
 *    normale add to cart.
 */
import { CartUpdateEvent } from '@theme/events';
import { fetchConfig } from '@theme/utilities';

function publish(name, payload) {
  try {
    window.Shopify?.analytics?.publish(name, payload);
  } catch (error) {
    // tracking mag de winkelwagen nooit in de weg zitten
  }
}

/** @param {HTMLButtonElement} button */
async function removeBundle(button) {
  const keys = (button.dataset.bundleKeys || '').split(',').filter(Boolean);
  if (!keys.length || button.disabled) return;

  const component = button.closest('cart-items-component');
  const sectionId = component instanceof HTMLElement ? component.dataset.sectionId : '';
  const row = button.closest('tr');

  button.disabled = true;
  row?.classList.add('cart-items__table-row--removing');

  const updates = Object.fromEntries(keys.map((key) => [key, 0]));
  const body = JSON.stringify({
    updates,
    ...(sectionId ? { sections: sectionId, sections_url: window.location.pathname } : {}),
  });

  try {
    const response = await fetch(window.Theme?.routes?.cart_update_url || '/cart/update.js', fetchConfig('json', { body }));
    const cart = await response.json();
    document.dispatchEvent(
      new CartUpdateEvent(cart, 'cart-bundle-remove', {
        source: 'cart-bundle-remove',
        itemCount: cart.item_count,
        sections: cart.sections,
      })
    );
  } catch (error) {
    button.disabled = false;
    row?.classList.remove('cart-items__table-row--removing');
  }
}

document.addEventListener('click', (event) => {
  const target = event.target instanceof Element ? event.target : null;
  if (!target) return;

  const bundleButton = target.closest('button[data-bundle-keys]');
  if (bundleButton instanceof HTMLButtonElement) {
    event.preventDefault();
    removeBundle(bundleButton);
    return;
  }

  const crossSell = target.closest('[data-cross-sell] button[name="add"]');
  if (crossSell) {
    const card = crossSell.closest('[data-cross-sell]');
    publish('cart_cross_sell_add', {
      product: card?.getAttribute('data-cross-sell'),
      from: card?.getAttribute('data-cross-sell-from'),
    });
  }
});
